import React from "react";
import { Link, useNavigate } from "react-router-dom";
import bgImage from '../assets/images/bg.jpeg';
import "../styles/auth.css";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="terms-page" 
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '60px 20px 140px 20px'
      }}
    >
      <div 
        className="content-container p-5 rounded" 
        style={{ 
          width: '95%',
          maxWidth: '1000px',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          border: '3px solid #000',
          position: 'relative'
        }}
      >
        {/* Go Back Button */}
        <button
          onClick={() => navigate('/')}
          className="btn btn-dark"
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            fontWeight: '700',
            textTransform: 'uppercase',
            fontSize: '0.8rem',
            padding: '5px 15px',
            borderRadius: '0',
            border: '2px solid #000'
          }}
        >
          Go Back
        </button>

        {/* Updated Headers to match Original Doc exactly */}
     
           <h1 className="text-center mb-2" style={{ color: "#000", fontWeight: "900", fontSize: "2.5rem",  }} >
            Terms & Conditions
          </h1>
          <h2 className="text-center mb-4" style={{ color: '#000', fontWeight: '700', fontSize: '1.5rem', textTransform: 'uppercase' }}>
            Blessed Builders – Sober Living Management Platform
          </h2>
      

        <div className="terms-text" style={{ color: '#000', lineHeight: '1.8' }}>
          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>1. Introduction</h4>
            <p>Welcome to Blessed Builders. These Terms & Conditions govern your access to and use of the Blessed Builders web portal and mobile application (collectively, the “Platform”).</p>
            <p>By accessing or using the Platform, you agree to comply with and be bound by these Terms. If you do not agree, you must not use the Platform.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>2. Eligibility</h4>
            <p>The Platform is intended for:</p>
            <ul>
              <li>Sober living operators</li>
              <li>House managers and staff</li>
              <li>Authorized residents</li>
            </ul>
            <p>Users must be at least 18 years of age or have appropriate authorization from a supervising organization.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>3. Services Provided</h4>
            <p>Blessed Builders provides a centralized management system designed for sober living operations, including but not limited to:</p>
            <ul>
              <li>Resident intake and document management</li>
              <li>Task and meeting management</li>
              <li>Secure messaging</li>
              <li>Real-time location tracking</li>
              <li>Program phase and progress tracking</li>
              <li>Payment and billing management</li>
              <li>Multi-home and staff administration</li>
            </ul>
            <p>All services are subject to continuous improvement and may be modified at any time.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>4. User Accounts & Responsibilities</h4>
            <p>Users are responsible for:</p>
            <ul>
              <li>Maintaining the confidentiality of login credentials</li>
              <li>Ensuring all provided information is accurate</li>
              <li>Using the Platform only for authorized purposes</li>
            </ul>
            <p>Organizations are responsible for:</p>
            <ul>
              <li>Managing user roles and permissions</li>
              <li>Ensuring proper use by staff and residents</li>
              <li>Monitoring compliance with internal policies</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>5. Acceptable Use</h4>
            <p>You agree not to:</p>
            <ul>
              <li>Use the Platform for unlawful or unauthorized purposes</li>
              <li>Share false, misleading, or harmful information</li>
              <li>Attempt to gain unauthorized access to other accounts or systems</li>
              <li>Interfere with the Platform’s functionality or security</li>
            </ul>
            <p>Blessed Builders reserves the right to suspend or terminate accounts that violate these terms.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>6. Data & Privacy</h4>
            <p>Blessed Builders prioritizes data security and confidentiality. The Platform includes secure systems for:</p>
            <ul>
              <li>Messaging</li>
              <li>Document storage</li>
              <li>Resident records</li>
            </ul>
            <p>By using the Platform, you consent to the collection and use of data necessary to provide services.</p>
            <p>Organizations are responsible for:</p>
            <ul>
              <li>Obtaining appropriate consent from residents</li>
              <li>Ensuring compliance with applicable privacy laws</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>7. Location Tracking</h4>
            <p>The Platform may include real-time location tracking features for residents. By using this feature:</p>
            <ul>
              <li>Users acknowledge that location data may be collected and displayed to authorized staff</li>
              <li>Organizations must obtain proper consent from residents before enabling tracking</li>
              <li>Tracking is intended for accountability and operational support—not surveillance or misuse</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>8. Payments & Billing</h4>
            <p>Blessed Builders may integrate with third-party payment providers (e.g., Stripe) for rent and billing management.</p>
            <ul>
              <li>All payments are processed securely via third-party providers</li>
              <li>Blessed Builders does not store full payment details</li>
              <li>Organizations are responsible for managing billing structures and disputes</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>9. Role-Based Access</h4>
            <p>Access to features is controlled by assigned roles (Admin, Manager, Assistant Manager, Guest).</p>
            <p>Organizations are responsible for:</p>
            <ul>
              <li>Assigning appropriate roles</li>
              <li>Reviewing and updating permissions as needed</li>
            </ul>
            <p>Blessed Builders is not liable for misuse resulting from improper role assignment.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>10. Availability & Updates</h4>
            <p>We strive to ensure continuous availability of the Platform. However:</p>
            <ul>
              <li>Service may be interrupted for maintenance or updates</li>
              <li>Features may change, improve, or be discontinued</li>
            </ul>
            <p>We are not liable for temporary disruptions or feature modifications.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>11. Intellectual Property</h4>
            <p>All content, software, and technology associated with Blessed Builders are the property of Blessed Builders.</p>
            <p>You may not:</p>
            <ul>
              <li>Copy, modify, or distribute the Platform</li>
              <li>Reverse engineer or attempt to extract source code</li>
            </ul>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>12. Limitation of Liability</h4>
            <p>Blessed Builders is provided “as is” without warranties of any kind.</p>
            <p>We are not liable for:</p>
            <ul>
              <li>Operational decisions made using the Platform</li>
              <li>Loss of data due to user error or external factors</li>
              <li>Misuse of features such as messaging or location tracking</li>
            </ul>
            <p>Organizations remain responsible for resident care, supervision, and compliance.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>13. Termination</h4>
            <p>We reserve the right to suspend or terminate access:</p>
            <ul>
              <li>For violation of these Terms</li>
              <li>For misuse of the Platform</li>
              <li>At our discretion, with or without notice</li>
            </ul>
            <p>Users may discontinue use at any time.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>14. Governing Law</h4>
            <p>These Terms shall be governed by and interpreted in accordance with applicable laws in your operating jurisdiction.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>15. Changes to Terms</h4>
            <p>Blessed Builders may update these Terms from time to time. Continued use of the Platform constitutes acceptance of the updated Terms.</p>
          </section>

          <section className="mb-4">
            <h4 style={{ fontWeight: '900', textTransform: 'uppercase' }}>16. Contact Information</h4>
            <p>For questions or support, please contact:</p>
            <p>Blessed Builders Sober Living Homes<br/>
            Address: 2700 State St. Ste F-6, Bismarck, ND 58503<br/>
            Phone: 701-751-0318</p>
          </section>
        </div>
      </div>

      {/* Footer Links */}
      <div className="login-footer-links w-100 text-center mt-5">
        <div className="d-flex justify-content-center align-items-center gap-2">
          <a
            href="https://blessedbuilderssoberliving.org/about-us"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            About Us
          </a>
          <span>|</span>
          <a
            href="https://blessedbuilderssoberliving.org/contact-us"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
          <span>|</span>
          <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
          <span>|</span>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;